import * as React from "react";
import Box from "@mui/material/Box";
import { Spinner } from "@fluentui/react";
import type { StatusDefinition } from "@shared/status/types";

const baseStyle = {
  borderRadius: 999,
  padding: "3px 10px",
  fontSize: "x-small",
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: "nowrap",
  display: "inline-block",
  textAlign: "center",
} as const;

export function StatusPill({
  status,
  isLoading,
  topRight,
}: {
  status: StatusDefinition;
  isLoading?: boolean;
  topRight?: boolean;
}) {
  const style = {
    ...baseStyle,
    ...(topRight ? { position: "absolute", top: 8, right: 8, zIndex: 1 } : {}),
    background: status.color,
    color: "#000000",
    border: `1px solid ${status.borderColor}`,
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: 100,
          padding: "4px 12px",
        }}
      >
        <Spinner size={1} />
      </Box>
    );
  }

  return (
    <Box className="load-status-pill" sx={style}>
      {status.status}
    </Box>
  );
}
